import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from "@angular/cdk/drag-drop";

import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalComponent } from '@shared/components/modal/modal.component';
import { SnackbarErrorComponent } from './components/snackbar-error/snackbar-error.component';
import { TaskforceComponent } from './components/taskforce/taskforce.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';

import { IconModule } from '../icon.module';
import { MaterialModule } from '../material.module';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { FirstLettersOfStringPipe } from './pipes/firstLettersOfString.pipe';
import { SplitPipe } from './pipes/split.pipe';
import { NoSanitizePipe } from './pipes/NoSanitizePipe';

@NgModule({
	imports: [
		CommonModule,
		DragDropModule,
		FormsModule,
		NgbModule,
		ReactiveFormsModule,
		RouterModule,
		MaterialModule,
		IconModule,		
	],
	declarations: [
		ModalComponent,
		SnackbarErrorComponent,
		ValidationErrorComponent,
		TaskforceComponent,
		StopPropagationDirective,
		NumbersOnlyDirective,
		FirstLettersOfStringPipe,
		SplitPipe,
		NoSanitizePipe
	],
	exports: [
		DragDropModule,
		FormsModule,
		NgbModule,
		ReactiveFormsModule,
		ValidationErrorComponent,
		MaterialModule,
		IconModule,
		TaskforceComponent,
		ModalComponent,
		StopPropagationDirective,
		NumbersOnlyDirective,
		FirstLettersOfStringPipe,
		SplitPipe,
		NoSanitizePipe
	],
	providers: [
		NgbActiveModal
	]
})
export class SharedModule {

}